import { Quote, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { useSite } from "@/lib/SiteContext";
import { REVIEWS } from "@/lib/reviews";

export const TestimonialsSection = () => {
  const { settings } = useSite();
  return (
    <section className="bg-slate-50 py-20 sm:py-28" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">What Our Clients Say</h2>
          <p className="mt-4 text-slate-600" data-testid="reviews-coming-soon">Client reviews coming soon.</p>
        </Reveal>
        {REVIEWS.length > 0 && (
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {REVIEWS.map((r, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 shadow-sm transition-shadow hover:shadow-md" data-testid={`testimonial-card-${i}`}>
                  <Quote className="h-6 w-6 text-teal-500" />
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">"{r.quote}"</p>
                  <div className="mt-6 border-t border-slate-100 pt-4">
                    <p className="text-sm font-bold text-navy">{r.name}</p>
                    {r.detail && <p className="mt-0.5 text-xs text-slate-500">{r.detail}</p>}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        )}
        {settings.google_review_url && (
          <Reveal delay={0.2} className="mt-10 text-center">
            <a href={settings.google_review_url} target="_blank" rel="noopener noreferrer" className="focus-ring inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-navy transition-all hover:-translate-y-0.5 hover:border-teal-500 hover:text-teal-700" data-testid="google-reviews-button">
              <Star className="h-4 w-4 text-teal-600" /> See Our Customer Reviews
            </a>
          </Reveal>
        )}
      </div>
    </section>
  );
};
